
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './plugins/element.js'
import md5 from 'js-md5';
Vue.prototype.$md5 = md5;
// 全局样式
import Element from 'element-ui'
import './styles/element-variables.scss'

// echarts 组件
import ECharts from 'vue-echarts'
import * as echarts from 'echarts'

import dragVerify from 'vue-drag-verify2'
// 视频组件
import VideoComponent from './components/VideoComponent';
// 音频组件
import AudioCompontent from './components/AudioCompontent'
import './utils/mainCommon.js'
import { getUuid } from '@/utils/fingerprint'
getUuid()
Vue.prototype.$echarts = echarts
Vue.component('VChart', ECharts)
Vue.component('VideoComponent', VideoComponent)
Vue.component('AudioCompontent', AudioCompontent)
import '@/styles/index.scss' // global css
import '@/assets/css/style.css'
Vue.config.productionTip = false
Vue.use(Element)
Vue.use(dragVerify)
new Vue({
  render: h => h(App),
  router,
  store
}).$mount('#app')
